import { Box, Container } from "@mui/material";
export default function PageContentWrapper({
  children,
  marginTop,
  noSideMargin = false,
  sideMargin = 3,
  maxWidth = "lg",
}) {
  if (noSideMargin) {
    return (
      <Box
        sx={{
          marginBottom: 3,
          marginTop: marginTop ? marginTop : 12,
          ml: sideMargin,
          mr: sideMargin,
        }}
      >
        {children}
      </Box>
    );
  }
  return (
    <Container
      maxWidth={maxWidth}
      sx={{ marginBottom: 3, marginTop: marginTop ? marginTop : 12 }}
    >
      {children}
    </Container>
  );
}
